<template>
  <v-snackbar style="margin-bottom: -20px" :color="snackbarColor" v-model="snackbar" class="text-xs-center pa-5" auto-height bottom :timeout="snackbarTimeout">
    <v-flex>
      <v-layout wrap justify-center>
        <span class="text-xs-center white--text" v-html="snackbarMessage"></span>
      </v-layout>
      <v-layout class="ml-0 mt-2" justify-center v-if="snackbarButton">
        <v-btn style="text-transform: none !important" class="ml-0 pa-2 px-3" @click="reset" color="green" round depressed>Fazer Novo Pedido</v-btn>
      </v-layout>
    </v-flex>
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['cartProducts']),
    snackbar: {
      get() {
        return this.$store.getters.snackbar;
      },
      set(value) {
        this.$store.dispatch('closeSnackbar');
      },
    },
    snackbarMessage() {
      return this.$store.getters.snackbarMessage;
    },
    snackbarButton() {
      return this.$store.getters.snackbarButton;
    },
    snackbarColor() {
      return this.$store.getters.snackbarColor;
    },
    snackbarTimeout() {
      return this.$store.getters.snackbarTimeout || 6000;
    }
  },
  methods: {
    async reset() {
      this.$store.dispatch('closeSnackbar');
      const evento = this.$store.getters.eventID;
      const checkoutState = JSON.parse(localStorage.getItem(`checkoutState`)) || {};
      this.cartProducts.forEach(product => {
        product.forEach(async el => {
          if(el.seats) {
            el.seats.forEach (async sc => {
              await this.$store.dispatch('unbookPurchaseSeats', sc)
            })
          }
        })
      });
      await this.$store.dispatch('deleteCheckoutState', evento);
      if (checkoutState && checkoutState[evento] && checkoutState[evento].userToken) await this.$store.dispatch('getClientData')
      await this.$store.dispatch('loadCheckoutState', evento);
      await this.$store.dispatch('resetSelection');
      await this.$store.dispatch('setResetPurchase', false);
    },
  }
};
</script>

<style scoped>
span {
  width: 100%;
}
</style>
